import { Grid } from "@mui/material";
import React from "react";
import AwesomeSlider from "react-awesome-slider";
import withAutoplay from "react-awesome-slider/dist/autoplay";
import "../assets/styles/scss/Slider.scss";

import { FaReact, FaNodeJs, FaAngular, FaLaravel } from "react-icons/fa";
import { SiRedux, SiMongodb, SiPostman, SiFirebase, SiMicrosoftazure } from "react-icons/si";

export default function Slider() {
  const AutoplaySlider = withAutoplay(AwesomeSlider);
  return (
    <AutoplaySlider
      bullets={false}
      className="slider"
      play={true}
      cancelOnInteraction={false}
      interval={5000}
    >
      <div className="slider-element" style={{ backgroundColor: "#14141f" }}>
        <Grid container spacing={{ xs: 5, sm: 10, md: 8, lg: 13, xl: 20 }}>
          <Grid item xs={4}>
            <FaReact className="icon" size={100} color="#61dafb" />
            <h6>React</h6>
          </Grid>
          <Grid item xs={4}>
            <SiRedux className="icon" size={100} color="#764abc" />
            <h6>Redux</h6>
          </Grid>
          <Grid item xs={4}>
            <FaAngular className="icon" size={100} color="#dd1b16" />
            <h6>Angular</h6>
          </Grid>
        </Grid>
      </div>
      <div className="slider-element" style={{ backgroundColor: "#14141f" }}>
        <Grid container spacing={{ xs: 5, sm: 10, md: 8, lg: 13, xl: 20 }}>
          <Grid item xs={4}>
            <FaNodeJs className="icon" size={100} color="#3c873a" />
            <h6>NodeJS</h6>
          </Grid>
          <Grid item xs={4}>
            <SiMongodb className="icon" size={100} color="#47a248" />
            <h6>MongoDB</h6>
          </Grid>
          <Grid item xs={4}>
            <SiPostman className="icon" size={100} color="#ff6c37" />
            <h6>Postman</h6>
          </Grid>
        </Grid>
      </div>
      <div className="slider-element" style={{ backgroundColor: "#14141f" }}>
        <Grid container spacing={{ xs: 5, sm: 10, md: 8, lg: 13, xl: 20 }}>
          <Grid item xs={4}>
            <SiFirebase className="icon" size={100} color="#ffca28" />
            <h6>Firebase</h6>
          </Grid>
          <Grid item xs={4}>
            <SiMicrosoftazure className="icon" size={100} color="#0089d6" />
            <h6>Azure</h6>
          </Grid>
          <Grid item xs={4}>
            <FaLaravel className="icon" size={100} color="#ff2d20" />
            <h6>Laravel</h6>
          </Grid>
        </Grid>
      </div>
    </AutoplaySlider>
  );
}
